import { Formik } from "formik";
import {
  MandatoryStar,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../../Utils/helper";
import { useEffect, useState } from "react";
import {
  GenerateUTRAction,
  GetPayableAction,
} from "../../../redux/actions/PayoutAction";
import { clearCurrentPage } from "../ProviderProfileDetails/helper";
import { useDispatch, useSelector } from "react-redux";
import { YUPValidations } from "./helper";
import { getNetworkMenuId } from "../../../Utils/types";
import { useLocation } from "react-router-dom";
import { GenerateInsurerUTRAction } from "../../../redux/actions/InsBillAction";

export const BankDetails = ({ searchFilter, submitUtr, setSubmitUtr }) => {
  const [data, setData] = useState(null);
  const [checkbox, setCheckbox] = useState(false);
  const dispatch = useDispatch();
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const location = useLocation();
  console.log(location);
  useEffect(() => {
    setData(submitUtr?.rowData);
    if (submitUtr?.rowData?.requestStatus === "Paid") {
      // setData(submitUtr?.rowData);
      setCheckbox(submitUtr?.rowData?.isFullPayment);
    }
  }, [submitUtr]);

  const handleClose = () => {
    setSubmitUtr({
      isOpen: false,
      rowData: null,
    });
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          {submitUtr?.rowData?.requestStatus === "Paid"
            ? "View UTR Detail"
            : "Submit Details"}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <Formik
        enableReinitialize={true}
        initialValues={{ ...data }}
        onSubmit={async (values) => {
          console.log("Form submitted!", YUPValidations);
          const temp = {
            ...values,
            ...searchFilter,
            bankAccountNumber: values?.bankAccountNumber,
            receiverName: values?.receiverName,
            bankName: values?.bankName,
            ifscCode: values?.ifscCode,
            amountPaid: values?.amountPaid,
            utrNumber: values?.utrNumber,
            paymentDate:
              values?.paymentDate || values?.paymentDate.split("T")[0],
            providerIds:
              location?.pathname === "/payout/Payables"
                ? [{ providerId: submitUtr?.rowData?.providerId }]
                : null,
            payid:
              location?.pathname === "/payout/Payables"
                ? submitUtr?.rowData?.payId
                : submitUtr?.rowData?.receiveId,
            month: submitUtr?.rowData?.month,
            paymentDate: values?.paymentDate,
            IsGeneratePayable: true,
            year: submitUtr?.rowData?.year,
            isFullPayment: checkbox,
            clients: [{ clientId: submitUtr?.rowData?.clientId }],
            totalAmount: values?.totalAmount,
            netAmount: values?.netAmount,
            tdsPercentage: values?.tdsPercentage,
            panNumber: values?.panNumber,
          };
          if (location?.pathname === "/payout/Payables") {
            if (values?.amountPaid <= 0) {
              alert("Amount paid should be greater than 0.");
              return;
            } else {
              console.log("Submit UTR for Testing ", temp);
              const resp = dispatch(GenerateUTRAction(temp));
              resp.then((res) => {
                isLoadingAction(true, dispatch);
                if (res?.data?.status === true) {
                  clearCurrentPage(dispatch);
                  getSnackbarSuccess("success", res?.data?.message, dispatch);
                  isLoadingAction(false, dispatch);
                  setTimeout(() => {
                    dispatch(GetPayableAction(searchFilter));
                  }, 1000);
                  handleClose();
                } else {
                  getSnackbarSuccess("error", res?.data?.message, dispatch);
                  isLoadingAction(false, dispatch);
                }
              });
            }
          } else if (location?.pathname === "/insurer/Receivables") {
            const resp = dispatch(GenerateInsurerUTRAction(temp));
            resp.then((res) => {
              isLoadingAction(true, dispatch);
              if (res?.data?.status === true) {
                clearCurrentPage(dispatch);
                getSnackbarSuccess("success", res?.data?.message, dispatch);
                isLoadingAction(false, dispatch);
                setTimeout(() => {
                  dispatch(GetPayableAction(searchFilter));
                }, 1000);
                handleClose();
              } else {
                getSnackbarSuccess("error", res?.data?.message, dispatch);
                isLoadingAction(false, dispatch);
              }
            });
          }
        }}
        // validationSchema={YUPValidations}
      >
        {(props) => {
          const { values, handleChange, handleSubmit, errors } = props;

          const ChangeHandler = (name, value) => {
            setData({ ...values, [name]: value });
          };

          return (
            <form className="form-admin" onSubmit={handleSubmit}>
              <div className="modal-body addusermodalbox bankDetail">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor=" Role" className="col-form-label">
                      Receiver's Name
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="receiverName"
                      type="text"
                      placeholder="Receiver's Name"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.receiverName}
                      onChange={handleChange}
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid" }
                    />
                    {/* <div className="errorInputMessage">
                      {errors?.receiverName}
                    </div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Bank Account No
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="bankAccountNumber"
                      type="text"
                      placeholder="Bank Account No"
                      className="form-control form-select-admin inputbgavanish"
                      value={values?.bankAccountNumber}
                      onChange={handleChange}
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid"}
                    />
                    {/* <div className="errorInputMessage">
                      {errors?.bankAccountNumber}
                    </div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Bank Name
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="bankName"
                      type="text"
                      placeholder="Bank Name"
                      className="form-control form-select-admin inputbgavanish"
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid" }
                      value={values?.bankName}
                      onChange={handleChange}
                    />
                    {/* <div className="errorInputMessage">{errors?.bankName}</div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      IFSC Code
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="ifscCode"
                      type="text"
                      placeholder="IFSC Code"
                      className="form-control form-select-admin inputbgavanish"
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid" }
                      value={values?.ifscCode}
                      onChange={handleChange}
                    />
                    {/* <div className="errorInputMessage">{errors?.ifscCode}</div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      PAN Number
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="panNumber"
                      type="text"
                      placeholder="PAN Number"
                      className="form-control form-select-admin inputbgavanish"
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid" }
                      value={values?.panNumber}
                      onChange={handleChange}
                    />
                    {/* <div className="errorInputMessage">{errors?.panNumber}</div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Gross Amount
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="grossAmount"
                      type="number"
                      placeholder="Gross Amount"
                      className="form-control form-select-admin inputbgavanish"
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid"}
                      value={values?.grossAmount}
                      onChange={handleChange}
                    />
                    {/* <div className="errorInputMessage">
                      {errors?.grossAmount}
                    </div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      TDS %{/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="tdsPercentage"
                      type="number"
                      placeholder="TDS %"
                      className="form-control form-select-admin inputbgavanish"
                      disabled={submitUtr?.rowData?.requestStatus === "Paid"}
                      value={values?.tdsPercentage}
                      onChange={(e) => {
                        const tdsPercentage = e.target.value;
                        const grossAmount = values.grossAmount;
                        const tdsAmount = (grossAmount * tdsPercentage) / 100;
                        values.netAmount =
                          grossAmount - (tdsAmount + values?.overAllDiscount);

                        ChangeHandler("tdsPercentage", e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Overall Discount
                      {/* <MandatoryStar /> */}
                    </label>
                    <input
                      name="overAllDiscount"
                      type="number"
                      placeholder="Overall Discount"
                      className="form-control form-select-admin inputbgavanish"
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid"}
                      value={values?.overAllDiscount}
                      onChange={handleChange}
                    />
                    {/* <div className="errorInputMessage">
                      {errors?.netAmount}
                    </div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Net Amount
                      <MandatoryStar />
                    </label>
                    <input
                      name="netAmount"
                      type="number"
                      placeholder="Net Amount"
                      className="form-control form-select-admin inputbgavanish"
                      disabled
                      // ={submitUtr?.rowData?.requestStatus === "Paid"}
                      value={values?.netAmount}
                      onChange={handleChange}
                    />
                    {/* <div className="errorInputMessage">{errors?.netAmount}</div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Amount Paid
                      <MandatoryStar />
                    </label>
                    <input
                      name="amountPaid"
                      type="number"
                      placeholder="Amount Paid"
                      className="form-control form-select-admin inputbgavanish"
                      disabled={submitUtr?.rowData?.requestStatus === "Paid"}
                      value={values?.amountPaid}
                      required
                      onChange={(e) => {
                        ChangeHandler("amountPaid", e.target.value);
                      }}
                    />
                    {/* <div className="errorInputMessage">
                      {errors?.amountPaid}
                    </div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      Payment Date
                      <MandatoryStar />
                    </label>
                    <input
                      name="paymentDate"
                      type="date"
                      placeholder="Centre SKU Name"
                      className="form-control form-select-admin inputbgavanish"
                      disabled={submitUtr?.rowData?.requestStatus === "Paid"}
                      onChange={handleChange}
                      value={
                        values?.paymentDate
                          ? values?.paymentDate.split("T")[0]
                          : null
                      }
                      max={new Date().toISOString().split("T")[0]}
                      required
                    />
                    {/* <div className="errorInputMessage">
                      {errors?.paymentDate}
                    </div> */}
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <label htmlFor="User Type" className="col-form-label">
                      UTR No.
                      <MandatoryStar />
                    </label>
                    <input
                      name="utrNumber"
                      type="text"
                      placeholder="UTR No."
                      className="form-control form-select-admin inputbgavanish"
                      disabled={submitUtr?.rowData?.requestStatus === "Paid"}
                      value={values?.utrNumber}
                      onChange={handleChange}
                      required
                      onKeyPress={(e) => {
                        const value = e.target.value;
                        // Allow only numbers and letters (both uppercase and lowercase)
                        const allowedChars = /^[a-zA-Z0-9\b.]+$/; // This allows alphanumeric characters and the decimal point
                        if (!allowedChars.test(e.key)) {
                          e.preventDefault(); // Prevent characters that are not numbers, letters, or the decimal point
                        }
                        // Prevent adding more than one decimal point
                        if (e.key === "." && value.includes(".")) {
                          e.preventDefault(); // Prevent decimal if it already exists
                        }
                        // Restrict to two decimal places if a decimal point is present
                        if (
                          value.includes(".") &&
                          value.split(".")[1].length >= 2 &&
                          e.key !== "Backspace" &&
                          e.key !== "."
                        ) {
                          e.preventDefault(); // Prevent entering more than two decimal places
                        }
                      }}
                    />
                    {/* <div className="errorInputMessage">{errors?.utrNumber}</div> */}
                  </div>
                </div>
                <div className="modal-footer modal-footer-admin justify-content-between accept-reject-btns bottom-0 d-flex mt-4">
                  <div className="col-lg-6 col-md-6 ">
                    <input
                      name="isFullPayment"
                      type="checkbox"
                      checked={checkbox}
                      disabled={submitUtr?.rowData?.requestStatus === "Paid"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setCheckbox(true);
                        } else {
                          setCheckbox(false);
                        }
                      }}
                    />
                    <label htmlFor="User Type" className="col-form-label ms-3">
                      Full Payment
                    </label>
                  </div>
                  <div>
                    {submitUtr?.rowData?.requestStatus !== "Paid" && (
                      <button
                        type="submit"
                        disabled={getNetworkMenuId()?.canEdit === false}
                        className="savedetails "
                      >
                        <img src="./../images/save-icon-white.png" alt="" />
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </>
  );
};
